<template>
  <div>
    <img src="../../assets/images/Vietcombank_logo.png" alt="">
  </div>
</template>

<script>
    export default {
        name: "IconVietcomBank"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/icons/IconVietcomBank.vue